import React from 'react';
import PropTypes from 'prop-types';
import { Fieldset } from '~/components/FormControl';
import { Col } from 'react-bootstrap';
import './DurabilityForm.scss';
import CheckboxGroup from '~/components/CheckboxGroup';

function DurabilityForm({ equipmentDurabilities, durabilities }) {
    return (
        <Col
            sm={3}
            className={'d-flex durability-form'}
        >
            <Fieldset className={'px-4'}>
                <Fieldset.Legend>Durabilities:</Fieldset.Legend>
                <CheckboxGroup
                    options={equipmentDurabilities}
                    fieldName="durabilities"
                    fieldValues={durabilities}
                    sm={6}
                />
            </Fieldset>
        </Col>
    );
}

DurabilityForm.propTypes = {
    equipmentDurabilities: PropTypes.array.isRequired,
    durabilities: PropTypes.array.isRequired,
};
export default DurabilityForm;
